import React from 'react';
import { Button } from 'primereact/button';
import { HelpBox } from 'components/v2/help-boxes';
import { FindButtonBox } from 'components/v2/form/styled';
import Tooltip from 'components/controls/Tooltip';
import { FieldPanelFullWidth, FieldPanelHeader } from 'styles/v2/Styles.styled';
import { HyperLink } from 'styles/Styles.styled';
import { DocumentActionState } from 'types/dynamic-forms/DocumentModelStateActions';
import { useDocumentStore } from '../hooks/useDocumentStore';
import { useDocumentActions } from '../hooks/useDocumentActions';

const RegistrationCertificatePanelRenderer: React.FC<any> = () => {
  const { state } = useDocumentStore();
  const { onGenerateRegistrationCertificate, isSpinnerVisible } = useDocumentActions();

  const actionState = state?.actions?.generateRegistrationCertificate;
  if (!actionState || actionState === DocumentActionState.Hidden) {
    return null;
  }

  const isDisabled = actionState === DocumentActionState.Disabled;

  return (
    <FieldPanelFullWidth>
      <FieldPanelHeader>Registration Certificate</FieldPanelHeader>
      <div>
        <HelpBox>
          <span>
            You can automatically generate a registration certificate for the <b>currently published EPD version</b>. An EPD
            update or new version is <b>not</b> required for this.
          </span>
          <span>
            The registration certificate will be accessible on the EPD details page at&nbsp;
            <HyperLink href="https://www.environdec.com/library" target="_blank" rel="noopener noreferrer">
              environdec.com
            </HyperLink>
            .
          </span>
        </HelpBox>
        <FindButtonBox style={{ marginTop: '10px', width: 'fit-content' }}>
          <Button
            style={{ fontSize: 14, fontWeight: 500 }}
            type="button"
            label={isSpinnerVisible ? 'Generating registration certificate...' : '+ Generate registration certificate'}
            text
            onClick={onGenerateRegistrationCertificate}
            disabled={isDisabled || isSpinnerVisible}
          />
          {isDisabled && !isSpinnerVisible && (
            <Tooltip position="bottom" offset={5}>
              A certificate already exists for the currently published EPD version. Another one can be generated only after
              publishing a new EPD version.
            </Tooltip>
          )}
        </FindButtonBox>
      </div>
    </FieldPanelFullWidth>
  );
};

export default RegistrationCertificatePanelRenderer;
